import { queryKeys } from '@/react-query/constants';
import { createFeatureApi } from '@/shared/api';

/** The media-plans feature roots on queryKeys.mediaPlans. Kept INTERNAL to the
 *  feature's api/ files; cross-cutting consumers invalidate via `mediaPlanKeys`
 *  (e.g. the shared file-preview components after an artwork mutation). */
export const mediaPlansApi = createFeatureApi(queryKeys.mediaPlans);

export const mediaPlanKeys = mediaPlansApi.keys;
